export const CHECKS_SCHEMA = 'checks';
